<template>
    <v-row
        no-gutters
        class="pl-9 pt-8"
    >
        <v-col
            cols="8"
            class="pr-10"
            style="word-break: normal"
        >
            <v-row no-gutters>
                <v-col v-html="$t('economic_app_overview_text')" /> <!-- INPUT FROM STATIC TRANSLATION -->
            </v-row>
        </v-col>
        <v-col cols="4">
            <AppStoreDialogSidebar />
        </v-col>
    </v-row>
</template>

<script>
import AppStoreDialogSidebar from "@/components/AppStore/AppStoreDialogSidebar";
import { computed } from "@vue/composition-api";
import appStoreDialog from "../../../store/modules/AppStoreDialog/appStoreDialog";

export default {
    name: "EconomicOverviewTab",
    components:{
        AppStoreDialogSidebar
    },
    setup(props, ctx) {
        const { appStoreDialogGetters } = appStoreDialog()
        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany()
        })

        return {
            selectedAccount
        };
    }
};
</script>
